// extracted by mini-css-extract-plugin
export default {"aboutWrapper":"css_aboutWrapper__ZrwG6","dev_page_content":"css_dev_page_content__3N08z"};